import type { ApiClient } from '@travel/api-client';

import type { TranslateRequest, TranslateResponse } from 'Translate-Types';

export const translate = (http: ApiClient, data?: TranslateRequest): Promise<TranslateResponse> =>
  http.post('/monterosa-api/translate', {
    headers: {},
    ignoreCommonErrorHandler: true,
    values: data,
  });
